import React from 'react';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { modalActions } from '../../redux/root-action';
import styled from 'styled-components';

const StyledContainer = styled.div<any>`
  max-height: ${props => `${props.maxHeight - 100}px`};
  overflow: auto;
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  padding: 0px 48px 32px 48px;
  color: ${tokens.ColorGrey800};
  @media only screen and (max-width: 767px) {
    overflow-x: hidden;
    padding: 0px 16px 0px 16px;
    height: ${props => `${props.maxHeight}px`};
    max-height: ${props => `${props.maxHeight}px`};
  }

  @media (max-width: 767px) and (orientation: landscape) {
    padding: 16px 16px 0px 16px;
  }

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: ${tokens.ColorWhite000};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${tokens.ColorWhite100};
    border-radius: 4px;
    border: 1px solid ${tokens.ColorWhite000};
  }
`;

class ReactModalContent extends React.Component<any> {
  props: any;
  render(): any {
    const { children, showGlobalError, footerHeight, headerHeight } = this.props;
    return (
      <StyledContainer
        id={`modal-content-containter`}
        showGlobalError={showGlobalError}
        maxHeight={window.innerHeight - (headerHeight + footerHeight)}
      >
        {children}
      </StyledContainer>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    footerHeight: state.modal.footerHeight,
    headerHeight: state.modal.headerHeight,
  };
};

export default connect(mapStateToProps, { hideModal: modalActions.hideModal })(ReactModalContent);
